var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSoftwareGradiant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 227,
    height: 145,
    viewBox: "0 0 227 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.544922,
    y: 0.333984,
    width: 225.819,
    height: 144.397,
    rx: 10.8174,
    fill: "url(#paint0_linear_795_2325)",
    fillOpacity: 0.6
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_795_2325",
    x1: 0.54492,
    y1: 72.5325,
    x2: 226.364,
    y2: 72.5325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9D89FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA6423"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoftwareGradiant);
export default __webpack_public_path__ + "static/media/softwareGradiant.98a5070b23029f02b6cb3b0960755861.svg";
export { ForwardRef as ReactComponent };